import { render } from "./ReplaceMediaDialog.vue?vue&type=template&id=06468532"
import script from "./ReplaceMediaDialog.ts?vue&type=script&lang=js"
export * from "./ReplaceMediaDialog.ts?vue&type=script&lang=js"

import "./ReplaceMediaDialog.vue?vue&type=style&index=0&id=06468532&lang=css"

import exportComponent from "/home/gitlab-runner/builds/jkm4GJjzS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__